import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../button/index';
import {
enteredContactSearchValue as setEnteredContactSearchValue,
isContactsAdvancedSearchDropDown as setIsContactsAdvancedSearchDropDown,
isContactsSearchAdvancedMode as setIsContactsSearchAdvancedMode,
isSearchingContacts as setIsSearchingContacts, resetContactSearchResult,
} from '../../../../../../../actions/contactActions';
import {isUpgradeToBusinessPopup as setIsUpgradeToBusinessPopup} from '../../../../../../../actions/popupActions';
import Criteria from './components/criteria';
import {urlStringToOperator} from '../../../../../../utils';
import {
addCriteria
} from '../../../../../../../actions/advanceSearchActions';
import './index.css';

function ContactsAdvancedSearch ({history}) {

	const contactSearchResult = useSelector((state) => state.contactReducer.contactSearchResult);
	const enteredContactSearchValue = useSelector((state) => state.contactReducer.enteredContactSearchValue);
    const isContactsAdvancedSearchDropDown = useSelector((state) => state.contactReducer.isContactsAdvancedSearchDropDown);
	const isUpgradeToBusinessPopup = useSelector((state) => state.popupReducer.isUpgradeToBusinessPopup);
	const hasTheBusinessPermission = useSelector((state) => state.permissionReducer.hasTheBusinessPermission);
	const advanceSearchCriteria = useSelector((state) => state.advanceSearchReducer.advanceSearchCriteria);
	const hasErrors = advanceSearchCriteria.some(crit => crit.error);

	let urlParams = [];

	const { t } = useTranslation();

	const dispatch = useDispatch();

	useEffect(() => {
		if(advanceSearchCriteria.length === 0){
			dispatch(addCriteria())
		}
	}, [dispatch, advanceSearchCriteria]);

	const proceed = (e) => {

		e.preventDefault();

		if(!hasTheBusinessPermission){
			if(!isUpgradeToBusinessPopup) {
				dispatch(setIsUpgradeToBusinessPopup(true));
			}

			if (isContactsAdvancedSearchDropDown) {
				dispatch(setIsContactsAdvancedSearchDropDown(false))
			}
			return;
		}

		dispatch(setIsContactsSearchAdvancedMode(true));
		dispatch(setIsSearchingContacts(true));

		/*
		* Reset classic contact search
		* */

		if(enteredContactSearchValue !== ""){
			dispatch(setEnteredContactSearchValue(""))
		}

		if(contactSearchResult) {
			if (contactSearchResult.contacts.length > 0) {
				dispatch(resetContactSearchResult());
			}
		}

		if (document.querySelector('.list-of-contacts-header .search-bar input')) {
			document.querySelector('.list-of-contacts-header .search-bar input').value = '';
		}

		e.currentTarget.querySelectorAll('.criteria').forEach( criteriaItem => {
			if(criteriaItem.children[2].children[1].value === "IS_EMPTY" || criteriaItem.children[2].children[1].value === "IS_NOT_EMPTY"){
				if(criteriaItem.children[1].children[1].value){
					urlParams.push(criteriaItem.children[1].children[1].value + urlStringToOperator(criteriaItem.children[2].children[1].value));
				}
			} else {
				if(criteriaItem.children[1].children[1].value && criteriaItem.children[2].children[1].value && criteriaItem.children[3].children[1].value){
					urlParams.push(criteriaItem.children[1].children[1].value + urlStringToOperator(criteriaItem.children[2].children[1].value) + criteriaItem.children[3].children[1].value);

				}
			}
		});

		// Webful In-App Analytics
		window.webful?.track('advanced_search_used', { criteria_count: urlParams.length });

		history.push('/contacts/search?q=' + urlParams.join(";"));

	};

	return (
		<div className="pt-2">
			<Button className='btn-link close mr-1' onClick={() => dispatch(setIsContactsAdvancedSearchDropDown(false))}>
				<svg width="20" height="20" viewBox="0 0 24 24" fill="none"
					 xmlns="http://www.w3.org/2000/svg">
					<path fill="currentColor"
						  d="m2.74,23.59l-2.32,-2.32l9.27,-9.27l-9.27,-9.27l2.32,-2.32l9.27,9.27l9.27,-9.27l2.32,2.32l-9.27,9.27l9.27,9.27l-2.32,2.32l-9.27,-9.27l-9.27,9.27z"
						  id="svg_1"/>
				</svg>
			</Button>
			<form autoComplete={'' + Math.random()} className="contacts-advanced-search" action="" method="post"
				  onSubmit={proceed}>
				<p className="lead text-center">{t('advancedSearchTitle')}</p>
				{advanceSearchCriteria && advanceSearchCriteria.length > 0 ? (
					advanceSearchCriteria.map((criteria, index) => (
						<Criteria
							key={criteria.id}
							id={criteria.id}
							index={index}
							field={criteria.field}
							operator={criteria.operator}
							value={criteria.value}
						/>
					))
				) : (
					<Criteria index={0} field={""} operator={""} value={""}/>
				)}
				<div className="text-right mt-3">
					<Button disabled={hasErrors} type="submit" className="btn-primary">Search</Button>
				</div>
			</form>
		</div>
	)
}

export default withRouter(ContactsAdvancedSearch);
